import ModelTypeConstants from 'constants/ModelTypeConstants';
import {DataTable} from 'notebook/data-tables/DataTableConstants';
import getNoteLinkedObjectsOfTypes from 'notebook/notes/util/getNoteLinkedObjectsOfTypes';
import {EntryNote, NoteLinkedObjectType} from 'notebook/util/NoteUtilConstants';
import {fillEmptyDataTableWithResults} from 'runs/assay-group/AssayGroupDataTables';
import {NoteLinkedAssayData} from 'runs/AttachmentConstants';

import {AssayResult} from './assays/AssayRecordConstants';

export function getAllDataTables(
  entryNote: EntryNote,
  getResultsForTableInRun?: (dataTable: DataTable, runId: string) => Array<AssayResult>
): Array<DataTable> {
  return getNoteLinkedObjectsOfTypes(entryNote, [
    ModelTypeConstants.DATA_TABLE,
    ModelTypeConstants.NOTE_LINKED_ASSAY_DATA,
  ]).flatMap((item: DataTable | NoteLinkedAssayData) => {
    if (item.type === NoteLinkedObjectType.DATA_TABLE) {
      return item;
    } else {
      return _getDataTablesFromNoteLinkedAssayData(item, getResultsForTableInRun);
    }
  });
}

export function getNumDataTables(entryNote: EntryNote): number {
  return getAllDataTables(entryNote).length;
}

function _getDataTablesFromNoteLinkedAssayData(
  nlad: NoteLinkedAssayData,
  getResultsForTableInRun?: (dataTable: DataTable, runId: string) => Array<AssayResult>
): Array<DataTable> {
  const runId = nlad.assayRunId;
  if (!runId) {
    // Standalone results were previously attached to the entry via NLAD, so filter out those
    // with no run ID
    return [];
  }
  return nlad.dataTables.map((dataTable: DataTable) =>
    getResultsForTableInRun
      ? fillEmptyDataTableWithResults(
          dataTable,
          getResultsForTableInRun(dataTable, runId),
          dataTable.config.assaySchema
        )
      : dataTable
  );
}
